import { Component, Input, OnInit, inject } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { first } from 'rxjs/operators';
import { EventsExportScope } from '../../models/eventsExport';
import { EventsExportService } from '../../services/events-export.service';
import { PassDataService } from '../../services/pass-data/pass-data.service';

// Presentational export menu (XLSX / CSV): the flow lives in
// EventsExportService, this only renders the trigger and tracks the
// in-flight state.
@Component({
  selector: 'urban-export-button',
  templateUrl: './export-button.component.html',
  styleUrls: ['./export-button.component.scss'],
  standalone: false,
})
export class ExportButtonComponent implements OnInit {
  @Input() public scope: EventsExportScope | null = null;
  // Unix seconds, usually the page searchbar dates. Both empty = backend
  // default (last 24h).
  @Input() public startDate: number | null = null;
  @Input() public endDate: number | null = null;
  @Input() public disabled: boolean = false;
  @Input() public iconOnly: boolean = false;

  public requesting: boolean = false;
  public icons: Record<string, SafeHtml> = {};

  private readonly exportService = inject(EventsExportService);
  private readonly passDataService = inject(PassDataService);

  public ngOnInit(): void {
    this.passDataService.sanIcons$.pipe(first()).subscribe(res => this.icons = res);
  }

  public export(format: 'csv' | 'xlsx'): void {
    if (!this.scope || this.requesting) {
      return;
    }

    this.requesting = true;

    this.exportService.export({
      ...this.scope,
      Format: format,
      ...(this.startDate && this.endDate ? { Start: this.startDate, End: this.endDate } : {}),
    }).subscribe(() => this.requesting = false);
  }
}
